import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PharmasetEditFormImpl from './PharmasetEditFormImpl';
import PharmasetList from './PharmasetList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PharmasetListView from './PharmasetListView'


export default function PharmasetDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.pharmasetDashboard);
  const [ pharmasetId, setPharmasetId] = React.useState('');
  const [reloadPharmasetList, setReloadPharmasetList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PharmasetEditFormImpl 
            setReloadPharmasetList={setReloadPharmasetList}
            pharmasetId={pharmasetId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PharmasetListView 
                      setPharmasetId = {setPharmasetId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
